import config from "../../common/Config";

const GestionCautionPage = () => {
  return (
    <iframe
      src={
        config.cautionURL +
        `/listCaution?token=${localStorage.getItem("token")}`
      }
      title="iframe"
      style={{
        marginTop: "-1.5vh",
        marginLeft: "22px",
        width: "97.95%",
        height: "88.2vh",
      }}
      sandbox="allow-scripts allow-same-origin allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-modals"
    ></iframe>
  );
};

export default GestionCautionPage;
